<template>
  <div class="container">
    <div>
      <img src='/static/img/coupon/bg.jpg'>
      <div class="main">

        <div class="coupon-cell">
          <div class="left">
            <template v-if=" orderList.type=='1' ">
              <div><span class="dollar">$</span><span class="amountBig">{{orderList.amount | numeral('0,0')}} </span></div>
              <div class="subtitle">立减券</div>
            </template>
            <template v-else=" orderList.type=='2' ">
              <div class="amountBig">{{100-orderList.amount}}%</div>
              <div class="subtitle">OFF</div>
            </template>
          </div>
          <div class="middle">
            <div class="box">
            </div>
            <div class="flexbox">
              <div>
                <div class="coupon-title">{{orderList.title}}</div>
                <div class="coupon-date">有效期至：{{orderList.end}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="weui-cells weui-cells_form radius" v-if="">
            <div class="weui-cell weui-cell_select weui-cell_select-before">
                <div class="weui-cell__hd">
                    
                    <select class="weui-select" name="select2">
                        <option value="1">🇦🇺+61</option>
                    </select>
                </div>
                <div class="weui-cell__bd">
                    <input class="weui-input" type="tel" pattern="[0-9]"  placeholder="请输入手机号" v-model="phone" >
                </div>
            </div>
        </div>

        <div class="btn-box">
          <div class="btn active" @click="claimCoupon()">立即领取</div>
        </div>
      </div>
      <div class="foot">© Service Today Australia Pty Ltd</div>
    </div>
  </div>


</template>

<script>
import qs from 'qs'

export default {
  name: 'order',
  data () {
    return {
      isSending:false,
      payFilter:99,
      orderList:{},
      isEmpty:false,
      phone:"",
    }
  },
  methods: {
    claimCoupon(val){
      if(this.isSending){
        return false;
      }
      else{
        let objectData={};
        let that = this;
        this.isSending = true;

        objectData.phone = this.phone;
        objectData.coupon_id = this.$route.query.id;

        this.axios.post(this.apiURL()+'/Globals/activityCoupons', qs.stringify(objectData))
        .then(function (response) {
          if(response.data.error_code==0){
            if(response.data.data.token){
              localStorage.token = response.data.data.token;
              localStorage.member_phone = response.data.data.member_phone;
              localStorage.member_name = response.data.data.member_name;
              localStorage.tempPasswd = response.data.data.password;
            }
            that.$router.push('/coupon-get-success')
          }
          else{
            alert(response.data.data)
          }
        })
        .catch(function (error) {
            alert("数据获取失败，请检查网络并重新尝试")
            that.isSending=false;
        });
      }
    },
    getList(){
      if(this.isSending){
        return false;
      }
      else{
        let objectData={};
        let that = this;
        this.isSending = true;

        objectData.coupon_id = this.$route.query.id;

        this.axios.post(this.apiURL()+'/Coupon/getCouponInfo', qs.stringify(objectData))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isEmpty=false;
            that.isSending = false;
            that.orderList = response.data.data;
            window.scrollTo(0,0);
          }
          else{
            that.$router.push('/')
          }
        })
        .catch(function (error) {
            alert("数据获取失败，请检查网络并重新尝试")
            that.isSending=false;
        });
      }
    },
  },
  computed: {
    service_period: function () {
      let result = '';
      switch (this.orderDetail.data.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("Sorry, we are out of service.");
      }
      return result;
    }
  },
  created: function () {
    if(!this.$route.query.id){
      this.$router.push('/')
    }
    else{
      this.getList();
      if(localStorage.member_phone){
        this.phone = localStorage.member_phone;
      }
    }
  },
  mounted: function () {
    if(this.checkLogin()){
      this.profileValidate();
    }
    else{
      this.isEmpty=true;
    }

    document.querySelector("html").classList.add("orange-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("orange-background");
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container{
  padding-top:0px;
}

.color-grey{
  color:#999;
}

.top-panel{
  position:fixed;
  left:0;
  top:0;
  width:100%;
  z-index:99;
}

.order-title{
  font-size:2em;
  color: #595D68;
  font-size: 20px;
  font-weight: bold;
  background:#fff;
  text-align:center;
  padding:1em 0 1em 0;
}

.payment-choose, .payment-choose-container{
  background:#fff;
}

.order-title-sub{
  padding:0 0 0 15px;
  color: #666;
  font-size: 16px;
  margin-bottom:2em;
}

.empty{
  padding:0 20vw;
  text-align:center;
  margin-top:6vh;
  color:#999;
}

.coupon-cell{
  background:#fff;
  border-radius:5px;

  .left{
    width:30%;
    text-align:center;
    padding: 12px 0;
    box-sizing: border-box;
    height: 100px;
  }
  .middle{
    width:70%;
    text-align:left;
    box-sizing: border-box;
    height: 100px;
    border-left: 1px dashed #ddd;
    position:relative;
    .flexbox{
      height:100px;
      display: flex;
      padding-left:20px;
      flex-direction: column;
      justify-content:space-around;
    }
  }
  .middle .box::after, .middle .box::before {
      content: '';
      position: absolute;
      width: 16px;
      height: 16px;
      background: #f6c59d;
      border-radius: 100%;
  }
  .middle .box::before {
      top: -8px;
      left: -8px;
  }

  .middle .box::after {
      bottom: -8px;
      left: -8px;
  }
  .right{
      width:24%;
      display: flex;
      text-align:center;
      flex-direction: column;
      justify-content:space-around;
  }
}

.payment-choose{
  border-bottom:1px solid #eee;
  width:100%;
  margin:0 auto 0 auto;
  display: flex;
  justify-content:space-evenly;
  .payment{
    padding:1em 0.2em 0 0.2em;
  }
  .payment.active{
    color:#fe9567;
    border-bottom: solid 3px #fe9567;
    padding-bottom:0.6em;
  }
}


.weui-btn_daojia{
  padding:2px 16px;
  color:#fff;
}

.coupon-cell{
  display: flex;
  justify-content:space-between;
}

.amountBig{
  font-size:2em;
  font-weight:bold;
  color:$color-orange;
}
.dollar{
  color:$color-orange;
  font-size:1.2em;
}
.subtitle{
  color:$color-orange;
  font-size:0.9em;
  margin-top:-8px;
}
.coupon-title{
  color:#595D68;
  font-weight:bold;
  line-height:1.2;
}

.coupon-date{
  color:#bbb;
  font-size:0.8em;
}

.daojia-navbar {
    position: fixed;
    background: rgba(255, 255, 255, 0.95);
    padding: 8px 10px;
    box-sizing: border-box;
    height: 50px;
}

.daojia-navbar-left {
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: left;
    span{
      font-size: 2em;
      color: #666;
    }
}

.daojia-navbar-middle_logo img{
    height:34px;
}

.daojia-navbar-middle {
    display: block;
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
    font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-family: sans-serif;
    font-size: 1.2em;
    line-height: 1.3;
    font-weight: bold;
}

.daojia-navbar-right {
    font-size: 14px;
    line-height: 26px;
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: right;
}

.main{
  margin:20px;
  border-radius:16px;
  background:#f6c59d;
  padding:20px;
}

.radius{
  border-radius:20px;
}

.btn{
  margin-top:20px;
  height:50px;
  background: linear-gradient(180deg, #FE5548 0%, #FE3921 100%)!important;
}

.foot{
  text-align:center;
  color:#fff;
  font-size:0.8em;
  margin-top:20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/coupon/get.vue